import { useApp } from '@/hooks/useApp';
import { useLogout } from '@/hooks/useLogout';
import { i18nCache } from '@/i18n/url';
import { adapterH5, appLayoutAdapter } from '@/utils/appLayoutAdapter';
import { NO_HEADER_H5_PATH } from '@/utils/constants';
import { isOAuthHeader } from '@/utils/oatu';
import { rtlAdapter } from '@/utils/rtl';
import { $tracing } from '@/utils/tracing';
import isApp, { isMobile } from '@/utils/ua';

interface IUniframe {
  header: any;
  footer: any;
  adaBot: any;
}

const UniframeHeaderFooter = ({ userInfo }: { userInfo: any }) => {
  const { setAntdLocale, supportLang } = useApp();
  const logout = useLogout();

  if (typeof window === 'undefined' || !window.BybitUniFrame) return;

  const handleLangChange = (lang: string) => {
    let antL = lang;
    //TODO: en-US -> en
    // if (!lang || lang === 'en-US') {
    if (!lang) {
      antL = 'en';
    }
    if (window.localStorage && supportLang(antL)) {
      localStorage.setItem('BYBIT_LANG_KEY', antL);
    }
    if (
      /^\/[a-z]{2,3}(-[A-Z]{2,3})?\/(notifications|user-feedback|unsubscribe|notifications-setting)[/]?$/.test(
        window.location.pathname,
      )
    ) {
      const pathName = window.location.pathname.replace(
        /^\/[a-z]{2,3}(-[A-Z]{2,3})?/,
        '',
      );
      window.location.href = `/${antL}${pathName}${window.location.search}${window.location.hash}`;
    }
    i18nCache.i18n.changeLanguage(antL);
    setAntdLocale(antL);
    // rtl布局
    rtlAdapter();
  };

  const handleLogout = () => {
    $tracing.addEvent({ t: 'action', c: 10024 });
    logout();
  };

  window.BybitUniFrame?.ready(
    ({
      header,
      footer,
      // transferAsset,
      // transferAccountConfig,
      adaBot,
    }: IUniframe) => {
      const { USER_INFO } = header.properties;
      const {
        USER_INFO: ADA_USER_INFO,
        LANG,
        HIDE_PAGE_URL,
      } = adaBot
        ? adaBot.properties
        : {
            USER_INFO: 'ADA_USER_INFO',
            LANG: 'LANG',
            HIDE_PAGE_URL: 'HIDE_PAGE_URL',
          };

      if (
        (!isMobile() ||
          NO_HEADER_H5_PATH.every(
            (pathname: string) => location.pathname !== pathname,
          )) &&
        !isOAuthHeader()
      ) {
        console.log(isMobile(), 'isMobile()');

        header
          .init({
            containerId: '__bybit_uniframe_header__',
          })
          .then(() => {
            const { LOGOUT, LANGUAGE_CHANGE } = header.events;
            let IS_HOME;
            if (header.properties) {
              IS_HOME = header.properties.IS_HOME;
            }

            header
              .setProperty(IS_HOME, true)
              .subscribeEvent(LOGOUT, () => {
                handleLogout();
              })
              .subscribeEvent(LANGUAGE_CHANGE, (lang: string) => {
                // const la = lang === 'en-US' ? 'en' : lang;

                handleLangChange(lang);
                adaBot && adaBot.setProperty(LANG, lang);
              });
            // header加载后隐藏
            adapterH5('header');
          });
        header.setProperty(USER_INFO, userInfo);

        setTimeout(() => {
          footer.init().then(() => {
            const { IS_GENERAL } = footer.properties;
            footer.setProperty(IS_GENERAL, true);
            isApp() && appLayoutAdapter();
          });

          // footer加载后隐藏
          adapterH5('footer');
        }, 4 * 1000);
      }

      // 初始化security
      setTimeout(() => {
        adaBot &&
          adaBot.init().then(() => {
            adaBot.setProperty(ADA_USER_INFO, userInfo);
            adaBot.setProperty(HIDE_PAGE_URL, ['/app/user/trading-tool']);
          });
      }, 8000);
    },
  );
  return <></>;
};

export default UniframeHeaderFooter;
